import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/*
 * Pxsol
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
   * @memberOf module:bs_168
   * @see {@link is_user_logged}
   *
   * @param {object} ctx - The context object.
   */
  engine.isUserLogged = function isUserLogged(ctx) {

    const isLogged = !!document.querySelector('.neo_pxuser_container');

    return isLogged;
  };

  /**
     *
     * @memberOf module:bs_168
     *
     * @param {object} ctx - The context object.
     */
  engine.boot = function boot() {
    const container = document.body;
    if (container) {
      let refreshPage = thn.debounce(thn.pageCheck, 800);

      thn.observeDom(container, refreshPage, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true,
      });

      thn.shutdown(() => {
        refreshPage.cancel();
        thn.stopObserveDom(container, refreshPage);
        refreshPage = null;
      });
    }

  };

  /**
     * @memberOf module:bs_168
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onStateChange = function onStateChange(ctx) {
    thn.pageCheck();
  };

  /**
    *
    * @memberOf module:bs_168
    *
    */
  const roomDetailsParseData = () => {

    const roomsArray = [...document.querySelectorAll('.ListItem')].map((room) => {
      const roomName = room.querySelector('.ListItem_Titulo')?.textContent;
      const roomType = getRoomType(roomName);
      const roomEl = [...room.querySelectorAll('.ListItem_TR')].map((rate) => {
        const rateName = rate.querySelector('.ListItem_Table > .ListItem_TR div > b')?.textContent;
        const ratePrice = thn.parseNumber(rate.querySelector('.wrap_precio')?.textContent);
        const hasBreakfast = !rate.querySelector('.px_cartservice_breakfast span, .breakfast-service span')?.textContent?.includes('No');
        const refundableRegex = /Reembolsable|Refundable|Reembolsável|Flexible|Flexível|Cancelación GRATUITA/;
        const isRefundable = refundableRegex.test(rate.querySelector('.px_cartservice_cancellationpolicy span:nth-child(3)')?.textContent?.trim());
        const rateData = {
          id: '',
          name: rateName,
          totalNight: ratePrice,
          breakfast: hasBreakfast,
          refundable: isRefundable,
        };

        return rateData;
      });

      const guestsArray = document.querySelector('.px_cartservice_guests span')?.innerText?.split('y');
      const roomData = {
        id: '',
        name: roomName,
        adults: thn.parseNumber(guestsArray?.[0]) || 2,
        children: thn.parseNumber(guestsArray?.[1]) || 0,
        type: roomType,
        prices: roomEl,
      };

      return roomData;
    });

    return roomsArray;
  };

  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};
    const $ = window.jQuery;

    if (!$) { return widgetData; }

    let dateIn = $('.busqueda_top_in_inv').text().match(/(\d{4})-(\d{2})-(\d{2})/);
    let dateOut = $('.busqueda_top_out_inv').text().match(/(\d{4})-(\d{2})-(\d{2})/);
    if (dateIn && dateOut) {
      widgetData.dateBegin = `${dateIn[1]}/${dateIn[2]}/${dateIn[3]}`;
      widgetData.dateEnd = `${dateOut[1]}/${dateOut[2]}/${dateOut[3]}`;
    } else {
      dateIn = $('.busqueda_top_in_inv').text().match(/(\d{2})\/(\d{2})\/(\d{4})/);
      dateOut = $('.busqueda_top_out_inv').text().match(/(\d{2})\/(\d{2})\/(\d{4})/);
      if (dateIn && dateOut) {
        widgetData.dateBegin = `${dateIn[3]}/${dateIn[2]}/${dateIn[1]}`;
        widgetData.dateEnd = `${dateOut[3]}/${dateOut[2]}/${dateOut[1]}`;
      }
    }

    widgetData.adults = thn.parseNumber($('.busqueda_top_personas_inv').text()) || 2;
    widgetData.children = 0;
    widgetData.guests = widgetData.adults + widgetData.children;

    const $prices = $('.ListItem_promotionalrate');
    const prices = $prices.map(function (key, e) {
      return thn.parseNumber($(e).text());
    }).toArray();

    if (prices.length) {
      widgetData.price = Math.min(...prices);
      widgetData.currency = thn.getCurrencyCode($prices.eq(0).text().match(/[^\d\s,.]+/)[0]);
      widgetData.roomDetails = roomDetailsParseData();
      widgetData.set = true;

    } else if ($('.sindispo').length) {
      widgetData.noRooms = true;
    }

    // widgetData.roomDetails = room_details_parse_data(widgetData);

    return widgetData;
  };

  engine.bookingParseData = function bookingParseData() {
    const widgetData = {};
    const dataLayer = window.dataLayer;

    const purchase = dataLayer.filter((el) => el?.[0] === 'event' && el?.[1] === 'purchase');
    const finalPurchaseData = purchase?.[purchase.length - 1];

    const bookingTitle = document.querySelector('.TituloVentana');

    // booking confirmed
    if (!thn.empty(bookingTitle)) {
      const priceSel = document.querySelector('.total')?.textContent;
      const currency = thn.objectGet(finalPurchaseData, 'currency');
      const price = thn.parseNumber(priceSel) || thn.objectGet(finalPurchaseData, 'value');
      const wrapper = document.querySelector('.wraper_budget')?.nextElementSibling?.querySelector('p')?.innerText;

      widgetData.price = price;
      widgetData.currency = currency;

      widgetData.dateBegin = thn.objectGet(finalPurchaseData, 'start_date')?.replace(/-/g, '/') || wrapper?.match(/(\d{2})\/(\d{2})\/(\d{4})/g)?.[0]?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
      widgetData.dateEnd = thn.objectGet(finalPurchaseData, 'end_date')?.replace(/-/g, '/') || wrapper?.match(/(\d{2})\/(\d{2})\/(\d{4})/g)?.[1]?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
      widgetData.adults = thn.parseNumber(wrapper?.match(/(Adultos|Adults): (\d+)/)?.[2]);
      widgetData.bookingId = thn.objectGet(finalPurchaseData, 'transaction_id') || bookingTitle.innerText?.split('#')?.[1];
    }

    return widgetData;
  };

  return engine;

}

export { factory };
